module.exports = __webpack_public_path__ + "img/logo_qclass_q_png.c95ea425.png";